
import React from "react";
import { Link } from "react-router-dom";

import logo from "../../assets/img/dyar_mobil_logo.png";

export default function EmailLegalNotice() {
  return (
    <div className="legal-page">
      <header className="legal-header">
        <Link to="/" className="legal-logo-link" aria-label="Vissza a főoldalra">
          <img src={logo} alt="DYAR logó" className="legal-logo" />
        </Link>
      </header>

      <main className="legal-content">
        <h1>Jogi nyilatkozat</h1>

        <p>
          Ez az üzenet, és annak bármely csatolt anyaga szigorúan bizalmas,
          kizárólag a címzett részére szól és szakmai titoktartás védelme
          alatt áll. Amennyiben nem Ön a címzett, az üzenet másolása,
          nyilvánossá tétele vagy egyéb módon történő felhasználása
          jogellenes és tilos.
        </p>

        <p>
          Kérjük, hogy amennyiben tévedés eredményeként kapta ezt az üzenetet,
          azonnal értesítse az üzenet küldőjét, és törölje az üzenetet
          eszközéről, valamint levelezőrendszeréből.
        </p>

        <p>Köszönjük.</p>
      </main>
    </div>
  );
}
